<div class="b-edit-panel__content" hide-empty>
  <ng-content select="f-facet[name=section],[facet-section],w-section"></ng-content>
</div>
<div class="b-edit-panel__actions" hide-empty>
  <ng-content select="f-facet[name=actions],[facet-actions]"></ng-content>
</div>